import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const BrelokiAksessuary: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Raznoe/kP5220011.jpg"},
        {src: "/image/Raznoe/kP9220010.jpg"},
        {src: "/image/Raznoe/kP4020155.jpg"},
        {src: "/image/Raznoe/kP4020151.jpg"},
        {src: "/image/Raznoe/kP4100182.jpg"},
        {src: "/image/Raznoe/kP6260014.jpg"},
        {src: "/image/Raznoe/kP5140003.jpg"},
        {src: "/image/Raznoe/kPA070006.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Брелоки и аксессуары из бисера",
        "Яркие красочные брелки и аксессуары из бисера (фотографии). Брелоки на основе квадратного столбика - сердечки, звездочка, цветок." +
        " Брелок Солнышко из шнура и бусин оплетенных бисером, мозаичный коврик, подставка под чашку в марокканском стиле."
    )

    return <>

        <h2>Брелоки и аксессуары из бисера</h2>
        <div className="row catalog">
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP5220011.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Объемные сердечки"
                     id="image-0"
                     onClick={viewImage}
                />
                <p className="name">Объемные сердечки</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP9220010.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Солнце"
                     id="image-1"
                     onClick={viewImage}
                />
                <p className="name">Брелок "Солнышко"</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP4020155.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Объемные цветы"
                     id="image-2"
                     onClick={viewImage}
                />
                <p className="name">Объемные цветы</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP4020151.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Объемная звездочка"
                     id="image-3"
                     onClick={viewImage}
                />
                <p className="name">Объемная звездочка</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP4100182.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Мозаичный коврик"
                     id="image-4"
                     onClick={viewImage}
                />
                <p className="name">Мозаичный коврик</p>
            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP6260014.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Подставка под чашку в марокканском стиле"
                     id="image-5"
                     onClick={viewImage}
                />
                <p className="name"><Link to="/podstavka">Подставка под чашку</Link></p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mP5140003.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Брелок"
                     id="image-6"
                     onClick={viewImage}
                />
                <p className="name">Брелок</p>

            </div>
            <div className="col-sm-6 col-lg-4 padding-side">
                <img src="/image/Raznoe/mPA070006.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="227" height="170"
                     alt="Брелок Таблетка"
                     id="image-7"
                     onClick={viewImage}
                />
                <p className="name"><Link to="/circle-brelok">Круглый брелок</Link></p>
            </div>
        </div>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default BrelokiAksessuary;

